<template>
  <master-main
    :addProperties="{
      isWizard: false,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('state.states')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('state.states')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('state.states'),
        data: 'state_details',
        property: 'state',
        minWidth: 100,
      },
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 180,
      },
    ]"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create
        v-if="renderComponent"
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        @refresh="refresh"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import i18n from 'src/i18n';
import MixinMenu from 'src/util/mixinMenu';
import { getDateToday } from 'src/util/Util';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import StateTable from 'src/views/Pages/Dashboard/Sigatoka/State/state-table';
import EditCreate from 'src/views/Pages/Dashboard/Sigatoka/State/EditCreate.vue';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '80%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinForm,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
    MixinRerender,
    MixinMenu,
  ],
  computed: {
    getModuleRoute() {
      return 'sigatoka/stateheader';
    },
    buildTableProperties() {
      return {
        tableColumns: [...StateTable().tableColumns],
        model: 'stateheader',
        effectTags: 'dark',
        defaultSort: { prop: 'name', order: 'ascending' },
        addColumns: [
          {
            data: 'state_details',
            label: i18n.t('state.states'),
            field: 'state',
          },
        ],
      };
    },
    dateToday() {
      return getDateToday();
    },
  },
};
</script>
